// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__23KPt","title":"FrontImage_title__2Tf4p"};